<template>
    <div class="page-center content-load">
        <div class="container">
            <div class="row">
                <div class="col-xl-4 col-md-6 col-lg-4 offset-xl-4 offset-md-3 offset-lg-4">

                    <center>
                        <img src="static/images/logo.png" width="180" class="logo">
                    </center>

                    <div class="login-register-page">
                        
                        <div class="welcome-text">
                            <h3>Olá, faça seu login</h3>
                            <span>Não possui uma conta?  <u><router-link :to="{'name': 'Cadastro'}"><b>Cadastre-se aqui</b></router-link></u>.</span>
                        </div>
                            
                        
                        <form method="post" id="login-form" v-on:submit.prevent="submit" novalidate="">
                            <div class="input-with-icon-left">
                                <i class="material-icons">email</i>
                                <input type="email" class="input-text with-border" autocomplete="new-password" name="email" id="email" placeholder="Informe seu e-mail de acesso" v-model="form.email" required/>
                            </div>

                            <div class="input-with-icon-left">
                                <i class="material-icons">lock</i>
                                <input type="password" class="input-text with-border" autocomplete="new-password" name="senha" id="senha" placeholder="Informe sua senha" v-model="form.senha" required/>
                            </div>
                            <a v-on:click="recuperarSenha" class="forgot-password" v-bind:class="{'disabled': loading.recuperarSenha}">Esqueceu sua senha?</a>
                            <button class="button full-width margin-top-10" v-bind:class="{'disabled': loading.submit}" type="submit" form="login-form">
                                <i class="material-icons">lock</i>
                                <span v-show="!loading.submit">Entrar</span>
                                <span v-show="loading.submit">Entrando</span>
                            </button>

                        </form>

                    </div>

                </div>
            </div>
        </div>
    </div>      
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            loading: {
                "recuperarSenha":   false,
                "submit":           false,
            },
            form: {
                "email":            null,
                "tipo":             "",
                "senha":            null
            }
        }
    },
    methods: {
        recuperarSenha: function(e) {
            var self            = this;
            console.log("recuperarSenha", e, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.recuperarSenha = true;
            loading.show();
            axios.post("api/recuperar-senha.php", self.form)
            .then(response => {
                loading.hide();
                self.loading.recuperarSenha = false;
                console.log("ok", response)
                alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.recuperarSenha = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        submit: function(e) {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));
            loading.show();
            e.preventDefault();
            self.loading.submit = true;
            form.senha          = md5(form.senha);

            axios.post("api/login.php", form)
            .then(response => {
                // self.loading.submit = false;
                if (response.data.user) {
                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            location.reload();
                        }, 200);
                    });
                } else {
                    loading.hide();
                }
                // alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }        
    },
    mounted: function() {
        loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .current-page-login .loading {
        top: 0px !important;
    }
    .page-login #wrapper {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .page-login .container {
        padding-left: 20px;
        padding-right: 20px;
    }
    .logo {
        width: 80%;
        margin-bottom: 5vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue